// Valide une adresse email
export function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
}

// Valide un numéro de téléphone
export function isValidPhone(phone) {
    const phoneRegex = /^[0-9]+$/;
    return phoneRegex.test(phone);
}

// Valide si une chaîne de caractères n'est pas vide
export function isValidString(input) {
    return input.trim() !== '';
}